module.exports = __webpack_public_path__ + "static/media/blue.119c11fe.png";